import { modalS } from "./../../stores/service";
import { firebase } from "../../firebase";

import db from "../../firebase";

export async function fetchServerTime(url) {
  let date = { status: true, date: "" };
  try {
    /*  ejemplo 
        'http://worldtimeapi.org/api/timezone/America/Mexico_City' */
    const response = await fetch(url);
    const data = await response.json();
    date.date = new Date(data.utc_datetime);
  } catch (error) {
    date.status = false;
    date.error = error;
  }
  return date;
}

export const createNewDate = async (zone) => {
  let newDate = { status:false,currentDate: "", year: "", month: "", day: "" };
    /* const currentDate = await fetchServerTime(
      `https://worldtimeapi.org/api/timezone/${zone}`
    ); */
  const currentDate = await firebasedate();
  
    if (currentDate.status) {
      newDate = {
        status: true,
        currentDate: currentDate.date,
        year: currentDate.date.getFullYear(),
        month: String(currentDate.date.getMonth() + 1).padStart(2, "0"),
        day: String(currentDate.date.getDate()).padStart(2, "0"),
      };
    } else {
      if (await ResolverConexion()) {
          createNewDate(zone);
        }
    }
    return newDate;
};

export async function ResolverConexion() {
    let res 
    modalS.update((values)=> {
      values.reset();
      values.info.title = "Aviso";
      values.info.body = `Error de red, intenta mas tarde`;
      values.controllers.btn[0].text = `Reintentar`;
      values.controllers.btn[1].text = `Cerrar`;
      values.controllers.btn[0].status = true;
      values.controllers.btn[1].status = true;
      values.status = true;
      return values
    }); 
  
      return new Promise((resolve, reject) => {
        modalS.update((value) => {
          value.resolve = resolve;
          value.reject = reject;
          return value;
        });
      });
    
  }

  export const firebasedate = async () => {
    let date = { status: true, date: "" };
  try {
    const timestamp = firebase.firestore.Timestamp.now();
    date.date =  timestamp.toDate();
    date.timestamp = timestamp;
  } catch (error) {
    date.status = false;
    date.error = error;
  }
    
    return date;
  };

 export function get_datastring(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${(mm, mm)}-${dd}`;
  }

  export function get_DateFirebase(date) {

    return {
      y:new Date(date.seconds * 1000).getFullYear(),
      m:new Date(date.seconds * 1000).getMonth() + 1,
      date: Date(date.seconds * 1000)
    };
  }